// Partitioned by Club so two Clubs never share a cache entry, and by `archived`
// so the working list and the archive do not overwrite each other.
export function rosterQueryKey(club_id: string, archived = false) {
	return ['roster', club_id, archived] as const;
}
